import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "timer-part timer-days"
}
const _hoisted_2 = { class: "timer__number" }
const _hoisted_3 = {
  key: 1,
  class: "timer-part timer-hours"
}
const _hoisted_4 = { class: "timer__number" }
const _hoisted_5 = {
  key: 2,
  class: "timer-part timer-min"
}
const _hoisted_6 = { class: "timer__number" }
const _hoisted_7 = {
  key: 3,
  class: "timer-part timer-sec"
}
const _hoisted_8 = { class: "timer__number" }

import { ref, computed, watch, onMounted } from "vue";
import Timer from "easytimer.js";
import { trans } from '@/utils/trans';


export default /*#__PURE__*/_defineComponent({
  __name: 'Timer',
  props: {
  dataDays: {
    type: Number,
    default: 0,
  },
  dataHours: {
    type: Number,
    default: 0,
  },
  dataMinutes: {
    type: Number,
    default: 0,
  },
  dataSeconds: {
    type: Number,
    default: 0,
  },
  dataCountdown: {
    type: Boolean,
    default: false,
  },
  isPaused: {
    type: Boolean,
    default: false,
  }
},
  setup(__props) {

const props = __props;

const timer = new Timer();

const days = ref(props.dataDays);
const hours = ref(0);
const minutes = ref(0);
const seconds = ref(0);

const lessThanDay = computed(() => days.value <= 0);

const updateTimer = () => {
  const values = timer.getTimeValues();
  days.value = values.days;
  hours.value = values.hours;
  minutes.value = values.minutes;
  seconds.value = values.seconds;
};

watch(
    () => props.isPaused,
    (isPaused) => {
      if (isPaused) {
        timer.pause();
      } else {
        timer.start();
      }
    }
);

onMounted(() => {
  timer.start({
    countdown: props.dataCountdown,
    startValues: {
      days: props.dataDays,
      hours: props.dataHours,
      minutes: props.dataMinutes,
      seconds: props.dataSeconds
    }
  });

  if (props.isPaused) {
    timer.pause();
  }

  updateTimer();

  timer.addEventListener('secondsUpdated', () => updateTimer());
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["timer", { 'one-day-left': lessThanDay.value }])
  }, [
    (!lessThanDay.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(days.value) + " " + _toDisplayString(_unref(trans)("live.common.timer.days")), 1)
        ]))
      : _createCommentVNode("", true),
    (hours.value > 0 && (!lessThanDay.value || lessThanDay.value))
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(hours.value) + " " + _toDisplayString(_unref(trans)("live.common.timer.hours")), 1)
        ]))
      : _createCommentVNode("", true),
    ((lessThanDay.value && minutes.value > 0) || (hours.value <= 0 && !lessThanDay.value))
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(minutes.value) + " " + _toDisplayString(_unref(trans)("live.common.timer.minutes")), 1)
        ]))
      : _createCommentVNode("", true),
    (hours.value < 1 && lessThanDay.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(seconds.value) + " " + _toDisplayString(_unref(trans)("live.common.timer.seconds")), 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})